export enum E_AiHelperState {
    Entry = 'entry',
    Idle = 'idle',
    Active = 'active',
    Exit = 'exit',
    Static = 'static',
    Closed = 'closed',
}

export enum E_AiHelperEvent {    
    Click = 'click',
    Drag = 'drag',  
    ReActive = 'reActive',
    Close = 'close',
    Timeout = 'timeout',
}
